import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Screen from "./components/screen";
import { shuffle, colour, colourName } from "./components/shuffle";
import Result from "./components/result";
import Start from "./components/start";

class App extends React.Component {

  state = {
    total: 0,
    colour: shuffle(colour)[0],
    colourName: shuffle(colourName)[0]
  }

  buttonPress = (buttonNumber, nameOfColour) => {
    if (buttonNumber === nameOfColour) {
        let newTotal = this.state.total + 1
        this.setState({ total: newTotal, colourName: shuffle(colourName)[0], colour: shuffle(colour)[0]})
        } else if (buttonNumber !== nameOfColour) {
        this.setState({ colourName: shuffle(colourName)[0], colour: shuffle(colour)[0] })
        }
}

resetScore = () => {
  this.setState({ total: 0, colour: shuffle(colour)[0], colourName: shuffle(colourName)[0] })
}
  
  render() {
    return(
    <div className="App">
      <Router>
      <h1 id="stroopTestHeader">Stroop Test</h1>
      <Route id="start" exact path="/" render={() => <Start />}></Route>
      <Route id="screen" exact path="/screen" render={() => <Screen total={this.state.total} colour={this.state.colour} colourName={this.state.colourName} buttonPress={this.buttonPress} />}></Route>
      <Route id="result" exact path="/screen/result" render={() => <Result reset={this.resetScore} total={this.state.total} />} />
      </Router>
    </div>
    )
  }
}

export default App;